import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d9de6b10&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d9de6b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9de6b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9de6b10')) {
      api.createRecord('d9de6b10', component.options)
    } else {
      api.reload('d9de6b10', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d9de6b10&scoped=true&", function () {
      api.rerender('d9de6b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/comp/DocBox.vue"
export default component.exports